module.exports = __webpack_public_path__ + "img/3.5a0325cf.png";